import { graphql } from '@/gql';

export const FetchGroups = graphql(`
    query FetchGroups($pagination: Pagination, $sort: GroupSortingRule, $filter: GroupFilteringRule) {
        groups(pagination: $pagination, sort: $sort, filter: $filter) {
            count
            items {
                ...GroupListItemData
            }
        }
    }
`);

const SubgroupListItemData = graphql(`
    fragment SubgroupListItemData on Subgroup {
        id
        name
        parentGroupId
        description
        memberCount
        memberUserIds
        createdAt
        updatedAt
    }
`);

const Member = graphql(`
    fragment Member on User {
        ... on TenantUser {
            id
            firstName
            lastName
            email
            roleAssignments {
                role
                assignedGroups {
                    groupId
                    subGroupIds
                    buddyIds
                }
            }
        }
        ... on SuperAdminUser {
            id
            firstName
            lastName
            email
            isSuperAdmin
        }
    }
`);

const CourseItem = graphql(`
    fragment CourseItem on Course {
        ... on CourseTemplate {
            id
            name
            description
        }
        ... on CourseInstance {
            id
            name
            description
        }
    }
`);

const GroupListItemData = graphql(`
    fragment GroupListItemData on Group {
        id
        name
        description
        createdAt
        updatedAt
        isDeletable
        totalMemberCount
        allMembers {
            ...Member
        }
        enrolledCourseIds
        enrolledCourses {
            ...CourseItem
        }
        subgroups {
            ...SubgroupListItemData
        }
    }
`);
